import { Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SubmissionService } from '../../../../http/intake/submission.service';
import { Subject, takeUntil } from 'rxjs';
import { IntakeClientSummaryModel } from '../../../../common/models/intake-client-summary.model';
import { StatusEnum } from '../../../../common/constants/status-enum';
import { IntakeConstant } from '../../../constants/intake.constant';
@Component({
  selector: 'app-intake-client',
  templateUrl: './intake-client.component.html',
  styleUrl: './intake-client.component.less',
})
export class IntakeClientComponent implements OnInit {

  clientSummaryData!: IntakeClientSummaryModel | undefined;
  unsubscriber$ = new Subject<void>();
  constructor(private readonly intakeService: SubmissionService,
    private readonly router: Router
  ) {}
  @Input() clientNumber: string = '';
  @Output() independenceDataEmitter = new EventEmitter<{
    services: string;
    servicesDescription: string;
    sapdgmfId: string;
  }>();
  clientnumberData: string = '';
  validGlobalProgramList = IntakeConstant.CLIENT_PROGRAM_LIST;
  globalProgram: string = IntakeConstant.EMPTY_SPACE;
  ngOnInit(): void {
    this.clientnumberData = this.clientNumber;
    this.intakeService
      .getIntakeClientSummary(this.clientNumber)
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe({
        next: (response: IntakeClientSummaryModel) => {
          this.clientSummaryData = response;
          this.clientSummaryData.clientStatus = response.clientStatus;
          if(this.validGlobalProgramList.includes(response.globalProgramName)){
            this.globalProgram = response.globalProgramName;
          }else{
            this.globalProgram = IntakeConstant.EMPTY_SPACE;
          }
          this.independenceDataEmitter.emit({
            services: response.services,
            servicesDescription: response.servicesDescription,
            sapdgmfId: response.sapdgmfId,
          });
        },
        error: (err) => {
          console.error('An error occurred during submission: ', err);
        },
      });
  }

  transformStatus(status: string): StatusEnum {
    return (
      Object.values(StatusEnum).find((enumValue) => enumValue === status) ||
      StatusEnum.Draft
    );
  }

  clientNameClicked(): void {
    this.router.navigate(['/client', this.clientNumber,'/details']);
  }

  ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }
}
